import React from 'react';
import { fmt, PARTY_STATUS_CONFIG } from '../../../../helper/storeQuotation';
import Swal from 'sweetalert2';
import axios from 'axios';
import { V_URL } from '../../../../BaseUrl';
import { Edit, Plus } from 'lucide-react';

const PartyList = ({ quotation, onAddRates, onViewRates, onRefresh }) => {

  const handleDeleteParty = async (party_id, name) => {
    Swal.fire({
      title: `Are you sure? ${name}`,
      text: "This action cannot be undone!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#535353',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.delete(`${V_URL}/prosafe/quotation/${quotation?._id}/delete-party`,
            {
              data: { party_id: party_id },
              headers: {
                Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
              }
            });
          if (res?.data?.success) {
            Swal.fire(
              'Deleted!',
              'The party has been removed from the quotation.',
              'success'
            )
            if (onRefresh) onRefresh();
          } else {
            Swal.fire(
              'Error!',
              'There was an issue deleting the party. Please try again.',
              'error'
            )
          }
        } catch (error) {
          Swal.fire(
            'Error!',
            'An unexpected error occurred.',
            'error'
          )
        }
      }
    })
  }

  return (
    <div className="table-responsive p-3">
      <table className="table border-0 custom-table comman-table">
        <thead>
          <tr>
            <th className="small fw-bold">Party Name</th>
            <th className="small fw-bold">Phone</th>
            <th className="small fw-bold text-center">Status</th>
            <th className="small fw-bold ">Total Amount (₹)</th>
            <th className="small fw-bold ">GST (₹)</th>
            <th className="small fw-bold">Net Amount (₹)</th>
            <th className="small fw-bold ">Loading Charge (₹)</th>
            <th className="small fw-bold">Payment Terms</th>
            <th className="small fw-bold text-center">Finalized</th>
            <th className="small fw-bold text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          {quotation.parties.length === 0 && (
            <tr>
              <td colSpan={9} className="text-center py-4 text-muted small italic">No parties added yet</td>
            </tr>
          )}
          {quotation.parties.map(p => {
            const pId = typeof p.party_id === 'object' ? p.party_id?._id : p.party_id;
            return (
              <tr key={pId}>
                <td className="fw-semibold">{p.party_snapshot?.name}</td>
                <td className="small text-muted">{p.party_snapshot?.phone}</td>
                <td className="text-center">
                  <span className="rounded-4 px-3 py-1" style={{
                    backgroundColor: `${PARTY_STATUS_CONFIG[p.party_status]?.color}22`,
                    color: PARTY_STATUS_CONFIG[p.party_status]?.color,
                    fontSize: "12px",
                    fontWeight: "500",
                  }}>
                    {PARTY_STATUS_CONFIG[p.party_status]?.label}
                  </span>
                </td>
                <td className="small">{fmt(p.total_amount)}</td>
                <td className="small text-muted">{fmt(p.total_gst)}</td>
                <td className="fw-bold text-success">{fmt(p.total_net_amount)}</td>
                <td className="small">{fmt(p?.loading_charge)}</td>
                <td className="small">{p.payment_terms || "-"}</td>
                <td className="text-center">
                  {p.is_finalized ? (
                    <span className="text-success"> ✓ Selected</span>
                  ) : p.party_status === "rejected" ? (
                    <span className="text-danger small fw-bold"> ✗ </span>
                  ) : "-"}
                </td>
                <td className="text-center d-flex align-items-center justify-content-end gap-2">
                  <div className="add-group gap-3">
                    {!quotation.is_finalized ? (
                      <>
                        <button
                          className="btn btn-sm btn-primary border-primary rounded-2"
                          onClick={() => onAddRates(pId)}
                        >
                          {p.party_status === "rate_received" ? <Edit size={15} /> : <Plus size={15} style={{ fontWeight: "900" }} />}
                        </button>
                        <button
                          onClick={() => handleDeleteParty(pId, p?.party_snapshot?.name)}
                          className='btn btn-sm btn-danger' style={{ padding: "7px 12px" }}>
                          <i className="fa fa-trash-can"></i>
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={() => onViewRates(pId)}
                        className="btn btn-sm rounded-2"
                        style={{ padding: "5px 10px", fontSize: "12px" }}
                        title="View Rates"
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PartyList;
